import React from "react";
import { ConfigSection } from "../ConfigSection";
import { StyledTextField } from "../StyledTextField";
import { validateSlop } from "../../utils/validation";
import { MatchPhraseConfigSectionProps } from "../../types";

export const MatchPhraseConfigSection: React.FC<
  MatchPhraseConfigSectionProps
> = ({ config, updateMatchPhraseConfig }) => (
  <ConfigSection
    title="Match Phrase Configuration"
    tooltip="This setting controls how strict the search is when looking for phrases (multiple words together). When set to 0, it looks for the exact phrase like 'red apple'. When set higher, it allows words to be separated by other words, so 'red delicious apple' could match 'red apple' if the setting allows it."
  >
    <StyledTextField
      fullWidth
      label="Slop"
      type="number"
      inputProps={{ min: 0, max: 100 }}
      value={config.matchPhraseConfig?.slop ?? ""}
      validate={validateSlop}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        updateMatchPhraseConfig({
          slop: value === "" ? undefined : parseInt(value),
        });
      }}
      helperText="How strict phrase matching is. Range: 0–100. 0 = exact phrase."
    />
  </ConfigSection>
);
